export default function () {
    var data = [];
    this.visit(function (node) {
        if (!node.length)
            do
                data.push(node.data);
            while (node = node.next);
    });
    return data;
}
